import { parseErrorMessage } from '@/utils/errorParser'
import { performLogout } from '@/utils/logout'

import { PRODUCT_OPERATIONS } from '@/config/productApi/operations'

const INVALID_CREDENTIALS_MESSAGE = 'invalid authentication credentials'

const getErrorDetail = err => {
  const detail =
    err?.detail ?? err?.errorData?.detail ?? err?.response?.data?.detail ?? err?.data?.detail

  return typeof detail === 'string' ? detail.toLowerCase() : ''
}

export const handleApiError = (err, config = {}, options = {}) => {
  const isInvalidCredentials = getErrorDetail(err) === INVALID_CREDENTIALS_MESSAGE
  const isAuthenticateOperation = options.operation === PRODUCT_OPERATIONS.AUTHENTICATE

  if (isInvalidCredentials && !isAuthenticateOperation) {
    void performLogout(config)
    return { handled: true }
  }

  const parsedMessage = parseErrorMessage(err)

  return {
    handled: false,
    error: {
      ...err,
      parsedMessage
    }
  }
}
